import React from "react";
import { FontIcon, mergeStyles, Stack } from "@fluentui/react";
import { makeStyles } from "@fluentui/react-components";


const useStyles = makeStyles({
    icon: {
        fontSize: '32px',
        marginRight: '0.625rem',
        '& svg': {
            width: '32px',
            height: '32px',
        }
    },
});


interface DeviceSelectionContainerProps {
    iconName: string;
    children: React.ReactNode;
}

export const DeviceSelectionContainer = (props: DeviceSelectionContainerProps): React.ReactNode => {
    const styles = useStyles();

    return (
        <Stack horizontal={true} grow={1}>
            <Stack.Item className={mergeStyles({ alignContent: 'center' })}>
                <FontIcon iconName={props.iconName} className={styles.icon} aria-setsize={32}  />
            </Stack.Item>
            <Stack.Item grow>
                {props.children}
            </Stack.Item>
        </Stack>
    );
}
